import { COUNTRIES } from "../../../../constants/countries";

/**
 * Longitudes de documentos de identidad por país
 * Esto centraliza las validaciones de longitud para cada tipo de documento
 */
export const DOCUMENT_LENGTHS = {
  [COUNTRIES.AR]: {
    CUIT_CUIL: 11, // Argentina: CUIT/CUIL tienen 11 dígitos
  },
  [COUNTRIES.DO]: {
    CEDULA: 11, // República Dominicana: Cédula tiene 11 dígitos (sin guiones)
  },
} as const;

/**
 * Obtiene la longitud esperada del documento según el país
 */
export const getDocumentLength = (countryCode: string): number => {
  switch (countryCode) {
    case COUNTRIES.DO:
      return DOCUMENT_LENGTHS[COUNTRIES.DO].CEDULA;
    case COUNTRIES.AR:
    default:
      return DOCUMENT_LENGTHS[COUNTRIES.AR].CUIT_CUIL;
  }
};

